/**
 * Names of the flags the territory list and the parcel map show. Which flag a
 * property gets is worked out on the server (Property::statusFlagSql), so the
 * list can sort by it; each kind names a pin image in
 * frontend/public/img/flag-pin-<kind>.svg.
 */

// The client's names, the last as the territory list's header words it.
export const STATUS_FLAG_TITLES = {
    green: 'On Market',
    neon: 'Summit Listings',
    red: 'Summit Closings',
    orange: 'Closed – Last 12 Mo',
};
